import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePresenceHeartbeat(enabled) {
  useEffect(() => {
    if (!enabled) return;
    const ping = () => { if (document.visibilityState === "visible") axios.post(`${API}/presence/ping`).catch(() => {}); };
    ping();
    const iv = setInterval(ping, 30000);
    document.addEventListener("visibilitychange", ping);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", ping); };
  }, [enabled]);
}

export function usePresenceStatus(userId, every = 15000) {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (!userId) { setStatus(null); return; }
    let alive = true;
    const load = () => axios.get(`${API}/presence/status`, { params: { ids: userId } })
      .then(r => alive && setStatus(r.data?.[userId] || null)).catch(() => {});
    load();
    const iv = setInterval(load, every);
    return () => { alive = false; clearInterval(iv); };
  }, [userId, every]);
  return status;
}

export function lastSeenLabel(status) {
  if (!status) return "";
  if (status.online) return "Online agora";
  if (!status.last_seen) return "Offline";
  const mins = Math.max(1, Math.round((Date.now() - new Date(status.last_seen).getTime()) / 60000));
  if (mins < 60) return `Visto há ${mins} min`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `Visto há ${hours} h`;
  return `Visto há ${Math.round(hours / 24)} d`;
}
